export default "/images/bousole.png?fb82892b08a0e5e933e7d52468b04688";